<template>
  <div class="Multiship">
    <div class="header">
      <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/shipping_header.svg?v=1657813497"/>
    </div>
    <div class="multiship-main-content">
      <div class="multiship-content">
        <p class="main-title"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_5257b419-6ffa-4278-bd91-46864bc15443.svg?v=1656613004"/>You're so close! Confirm shipping options below <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_5257b419-6ffa-4278-bd91-46864bc15443.svg?v=1656613004"/></p>
        <div class="alert-banner">
          <p class="main-copy">Note: The recipient must redeem the gift inside the US</p>
        </div>
        <div class="how-ship">
          <p class="subtitle">NOTE: The page will reload.</p>
          <div class="toggles-container">
            <div class="toggle-container">
              <p>Ship to multiple addresses</p>
              <label class="switch">
                <input :disabled="isProcessing" @change="changeShipping(true)" v-model="multishipChecked" type="checkbox">
                <span class="slider round"></span>
              </label>
            </div>
            <div class="toggle-container">
              <p>Ship all boxes to one address</p>
              <label class="switch">
                <input :disabled="isProcessing" @change="changeShipping(false)" v-model="singleCheckoutChecked" type="checkbox">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="boxes-container">
          <CartItem 
          v-for="(item,i) in lineItems" 
          @openform="openForm" 
          :key="item.key" 
          :cartItem="item" 
          :position="i" 
          :formData="formData"
          />
        </div>
        <div class="footer-checkout" >
          <button @click="multishipCheckout" :disabled="!canSubmit" class="happybox-button yellow" :class="isLoading ? 'isLoading' : ''">{{buttonText}}</button>
        </div>
      </div>
      <Summary :isLoading="isLoading" :canSubmit="canSubmit"/>
    </div>
    <EmailModal
    :product="currentItem"
    @close="closeForm"
    @end="updateModalInfo"
    v-if="currentItem && formIsOpen"
    />
    <div v-if="isProcessing" class="spinner-container">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import Summary from './components/Summary.vue'
import CartItem from './components/CartItem.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import EmailModal from './components/EmailModal.vue';
import { mapGetters } from 'vuex';
import axios from "axios";
require('dotenv').config();



export default {
  components:{
    Summary,
    CartItem,
    EmailModal
  },
  data(){
    return{
      formIsOpen: false,
      formData: {},
      currentItem: null,
      isLoading: false,
      multishipChecked: true,
      singleCheckoutChecked: false,
      isProcessing: false,
      instructionClicked: true,
      invalidProducts: [],
      emailProducts: [],
      addressesData: [],
    };
  },
  computed:{
    ...mapGetters([
      'currentCart',
      'addonProducts',
    ]),
    lineItems(){
      if(this.currentCart)
        return this.currentCart.items.filter(x => !x.properties["Added to"] && x.product_type != "Box" && x.product_type != "Card" && x.product_type != "Gift Collection");
      return [];
    },
    canSubmit(){
      let canSubmit = true;
      
      return canSubmit;
    },
    numberOfBoxes(){
      if(this.currentCart){
        var boxes = this.currentCart.items.filter(x => x.properties._gs_bundle_ids);
        return boxes.map(x => x.quantity).reduce((prev, next) => prev + next, 0);
      }
      else {
        return 0;
      }
    },
    hasBundles(){
      if(this.currentCart)
        return this.currentCart.items.some(x => x.product_type == "GIST_BUILDER_PRODUCT");
      
      return false;
    },
    buttonText(){
      return this.isLoading ? "loading..." : "PROCEED TO CHECKOUT"
    },
  },
  methods:{
    openForm(item){
      this.currentItem = item;
      this.formData = {};
      this.formIsOpen = true;
    },
    closeForm(item){
      this.formIsOpen = false;
    },
    updateModalInfo(file){
      this.formData = file;
      this.formIsOpen = false;
      this.emailProducts.push(file);
    },
    changeShipping(multishipCheck){
      this.isProcessing = true;
      if(multishipCheck){
        this.singleCheckoutChecked = !this.multishipChecked;
      }
      else {
        if(this.singleCheckoutChecked)
          this.multishipChecked = !this.singleCheckoutChecked;
      }
      this.goToSingleCheckout();
    },
    goToSingleCheckout(){
      let bundles = this.currentCart.items.filter(x => x.product_type == "GIST_BUILDER_PRODUCT");
      let items = [];
      if(bundles.length > 0){
          for(let bundle of bundles){
          let bundleQty = bundle.quantity;
          for(let i = 0; i < bundle.properties._gs_bundle_ids.length; i++){
            if(items.length > 0){
              let itemIndex = items.findIndex(x => x.id == bundle.properties._gs_bundle_ids[i])
              if(itemIndex > -1){
                items[itemIndex].quantity += bundle.properties._gs_bundle_quantities[i] * bundleQty;
                continue
              }
            }
            items.push({"id": bundle.properties._gs_bundle_ids[i],"quantity": bundle.properties._gs_bundle_quantities[i] * bundleQty,"properties" : {"Added to": "Box Bundle","_gs_bundle_item": "true"}});
          }
        }
        jQuery.ajax({
          url: '/cart/add.js',
          type: 'post',
          dataType: 'json',
          data: { items: items }
        })
        .done(function(response) {
          localStorage.setItem('_gs-redirect',true);
          location.href = "/checkout";
        })
        .fail(error =>{
          console.log(error);
        })
      }
      else {
        localStorage.setItem('_gs-redirect',true);
        location.href = "/checkout";
      }
    },
    clickInstruction(){
      this.instructionClicked = !this.instructionClicked;
    },
    validateInventory(){
      let invalidProducts = [];
      let variantsQty = [];
      for(let cartItem of this.lineItems){
        let isBox = cartItem.properties._gs_bundle_ids ? true : false;
        if(isBox){
          for (let id of cartItem.properties._gs_bundle_ids.slice(0, -3)){
            let index = cartItem.properties._gs_bundle_ids.indexOf(id);
            variantsQty.push({id: id,qty:cartItem.properties._gs_bundle_quantities[index] * cartItem.quantity});
          }
        }
        else {
          variantsQty.push({id: cartItem.variant_id,qty:cartItem.quantity});
        }
      }
      let variantsIds = variantsQty.map(x => x.id);
      var products = this.addonProducts.filter(x => x.variants.some(y => variantsIds.includes(y.id)));
      if(products.length > 0){
        for(let item of variantsQty){
          let currentProduct = products.find(x => x.variants.some(y => y.id == item.id));
          let currentVariant = currentProduct.variants.find( x => x.id == item.id);
          if(currentVariant.inventory_policy == "continue"){
            currentVariant.inventory_quantity = 99999;
          }
          if(currentVariant.inventory_quantity < item.qty){
            let title = currentVariant.title != "Default Title" ? `${product.title} - ${currentVariant.title}` : currentProduct.title;
            invalidProducts.push({title: title, product: currentProduct, variant: currentVariant});
          }
        }
      }
      

      this.invalidProducts = invalidProducts;

      return invalidProducts.length < 1;
    },
    openOOSModal(){
      var productTitles = this.invalidProducts.map(x => x.title);
      const alertText = "The following products dont have enough inventory to match the number of boxes: " + productTitles.join(", ") + ".";
      Swal.fire({
        title: 'Whoops!',
        text: alertText,
        icon: 'error',
        customClass:{
            container:"swal-custom-container",
            popup: "swal-custom-popup",
            title:"swal-title",
            confirmButton: "happybox-button yellow",
        },
        buttonsStyling: false,
        });
    },
    enter(element) {
      const width = getComputedStyle(element).width;

      element.style.width = width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const height = getComputedStyle(element).height;

      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      // Trigger the animation.
      // We use `requestAnimationFrame` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    leave(element) {
      const height = getComputedStyle(element).height;
      
      element.style.height = height;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    },
    async multishipCheckout(){
      this.isLoading = true;
      this.selectedAddresses = [];
      this.invalidProducts = [];
      this.addressesData = [];
      let hasInventory = this.validateInventory();
      if(!hasInventory){
        this.openOOSModal();
        this.isLoading = false;
        return;
      }

      let newAddress = {
        name: `Shipping Price`,
        address1: "720 Monroe Street",
        city: "Hoboken",
        state: "New Jersey",
        country: "United States",
        zip: "07030",
        phone: "",
      };

  
      console.log(this.emailProducts);
      for(let product of this.emailProducts){
        let properties = product.product.properties;
        delete properties.productImages
        //remove gs properties
        properties.gs_bundle_contents = properties._gs_bundle_contents;
        delete properties._gs_bundle_contents;
        properties.gs_bundle_discount = properties._gs_bundle_discount;
        delete properties._gs_bundle_discount;
        properties.gs_bundle_ids = properties._gs_bundle_ids;
        delete properties._gs_bundle_ids;
        properties.gs_bundle_prices = properties._gs_bundle_prices;
        delete properties._gs_bundle_prices;
        properties.gs_bundle_quantities = properties._gs_bundle_quantities;
        delete properties._gs_bundle_quantities;
        //Add email properties
        properties.gif = product.gif;
        properties.notificationDate = product.notificationDate;
        properties.message = product.message;
        properties.emailShipping = product.compressedEmails;

        let price = properties.gs_bundle_prices.reduce((partialSum,a) => partialSum + a,0);
        let data = {
          variant_id: product.product.variant_id
          ,product_id: product.product.product_id
          ,quantity: product.product.quantity
          ,address: newAddress
          ,properties: properties
          ,itemPrice: price
        }
        this.addressesData.push(data)
      }
      let priceList = this.emailProducts.map((x) => {
        let price = 1500;
        if(x.product.properties.XL){
          price = 1900;
        }
        return price * x.product.quantity;
      })
      let price = priceList.reduce((prev, next) => prev + next, 0);
      let name = "UPS® Ground";
      this.selectedAddresses.push({address: newAddress,shipping:[{name:name,price:price}],selected:null})

      this.getMultiship();
    },
    async getMultiship(){
      let shippingLines = this.selectedAddresses.map((x) =>{
        return { name:x.shipping[0].name,price:x.shipping[0].price,address:x.address};
      })
      var giftShipData = {myshopify_url:"happy-box-store.myshopify.com",line_items:this.addressesData,shipping_lines:shippingLines};
      var jsonData = JSON.stringify(giftShipData);
      var checkoutData = await this.getGiftShipCheckout({jsonData:jsonData});
      ga('send', {
        hitType: 'event',
        eventCategory: 'Multiship',
        eventAction: 'Navigation',
        eventLabel: `Finish`
      });
      localStorage.setItem('_gs-redirect',true);
      location.href = checkoutData.data.checkout_url;
    },
    async getGiftShipCheckout(jsonData){
      return await axios
        .post('https://api.happyboxstore.com/api/bundle/multiship',jsonData
        ).catch((err) => {
          console.log(err);
        });
    },
  },
}
</script>

<style scoped>
  .multiship-content{
    width: 67%;
  }

  .mailto{
    color: #b5a4c9;
  }

  .mailto:hover{
    font-weight: bold;
    text-decoration: underline;
  }

  .happybox-button.white{
    font-size: 1.2vw;
    padding: 1% 4%;
    font-weight: normal;
  }

  .happybox-button.white.selected{
    background-color: #F5EEFE;
  }
  .header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 2% 34% 2% 5%;
  }

  .multiship-main-content{
    width: 100%;
    display: flex;
    padding: 0% 5% 2%;
    position: relative;
    align-items: flex-start;
  }

  .how-ship .title{
    font-weight: 700;
    font-size: 1.8vw;
    line-height: 1.4;
    color: #0F0C38;
    text-align: center;
    margin: unset;
  }

  .how-ship .subtitle{
    font-size: 1vw;
    line-height: 1.2;
    margin-bottom: 5%;
    color: #0F0C38;
    text-align: center;
  }

  .boxes-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 3%;
    padding-right: 10%;
  }

  .multiship-content .main-title{
    text-align: center;
    font-size: 2.5vw;
    color: #0f0c38;
    font-family: 'moret';
    font-weight: 300;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
    margin-bottom: 1%;
  }

  .multiship-content .main-title img{
    width: 3%;
    margin: 0% 1%;
  }

  .close-banner{
    font-size: 1.5vw;
    height: 2vw;
    width: 2vw;
    border-radius: 50%;
    background-color: white;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -1vw;
    right: -1vw;
    z-index: 1;
    border: 1px solid;
    cursor: pointer;
    transition: all 0.5s;
  }

  .alert-banner{
    background-color: #ffeede;
    border-radius: 4px;
    font-size: 1vw;
    line-height: 1.4;
    color: #0F0C38;
    padding: 2% 5%;
    text-align: left;
    margin-bottom: 2%;
    position: relative;
  }

  .alert-banner p{
    margin: unset;
  }

  .alert-banner .main-copy{
    display: flex;
    align-items: center;
  }

  .alert-banner .main-copy strong{
    margin-left: 1%;
  }

  .alert-banner .open-instructions{
    font-size: 1.5vw;
    height: 2vw;
    width: 2vw;
    border-radius: 50%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid;
    cursor: pointer;
    transition: all 0.5s;
    margin-left: 2%;
  }

  .shipping-instructions{
    color: blue;
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
  }

  .text-container .subtitle{
    font-size: 1vw;
    line-height: 1.4;
    color: #0F0C38;
    padding: 2% 0%;
    margin: unset;
    display: block;
  }

  .text-container .subtitle:hover span{
    text-decoration: underline;
  }

  .text-container .subtitle span{
    cursor: pointer;
  }

  .text-container .happybox-button{
    font-weight: bold;
    width: 40%;
  }

  .toggles-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .toggle-container:first-child{
    border-right: 1px solid #c9b8f9;
  }

  .toggle-container{
    display: flex;
    width: 50%;
    justify-content: space-between;
    align-items: center;
    padding: 2% 5%;
    border-top: 1px solid #c9b8f9;
    border-bottom: 1px solid #c9b8f9;
  }
  
  .toggle-container p{
    line-height: 1.2;
    font-size: 1.2vw;
    margin: unset;
  }
  .footer-checkout{
    text-align: right;
    margin: 3% 0%;
  }

  .footer-checkout .happybox-button{
    width: 42%;
    padding: 1.5%;
  }

  .expand-enter-active,
  .expand-leave-active {
    transition: height 1s ease-in-out;
    overflow: hidden;
  }

  .expand-enter,
  .expand-leave-to {
    height: 0;
  }

  .spinner-container{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.1);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.3);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f;
    animation: spin 1s ease infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }


  @media screen and (max-width: 767px) {
    .header{
      padding: unset;
    }
    .multiship-main-content{
      flex-direction: column;
      padding: 5% 5%;
    }

    .alert-banner{
      font-size: 3vw;
      text-align: center;
      padding: 3%;
    }

    .how-ship .title{
      font-size: 4vw;
    }

    .how-ship .subtitle{
      font-size: 2vw;
    }

    .boxes-container{
      padding: unset;
    }

    .multiship-content{
      width: 100%;
    }

    .happybox-button.white{
      font-size: 3.5vw;
      margin-right: 5%;
      margin-top: 2%;
      margin-bottom: 2%;
    }

    .shipping-banner{
      flex-direction: column;
      text-align: center;
    }

    .shipping-banner .text-container,.shipping-banner .button-container{
      width: 100%;
      justify-content: center;
    }

    .shipping-banner .title{
      font-size: 4vw;
    }

    .shipping-banner .subtitle{
      font-size: 3vw;
    }

    .shipping-banner .subtitle span{
      text-decoration: underline;
    }

    .shipping-banner .happybox-button{
      margin: 3% 0%;
      padding: 2% 10%;
    }

    .footer-checkout{
      display: none;
    }

    .multiship-content .main-title{
      font-size: 7vw;
    }

    .multiship-content .main-title img{
      width: 15%;
    }

    .toggle-container p{
      font-size: 3.5vw;
    }

    .text-container .subtitle{
      font-size: 3vw;
    }

    .text-container{
      flex-direction: column;
    }

    .close-banner{
      height: 6vw;
      width: 6vw;
      font-size: 4vw;
      top: -3vw;
      right: -3vw;
    }

    .alert-banner .open-instructions{
      height: 6vw;
      width: 6vw;
      font-size: 4vw;
    }

    .toggles-container{
      flex-direction: column;
    }

    .toggle-container{
      width: 100%;
    }

    .toggle-container:first-child{
      border-right: unset;
      border-bottom: unset;
    }

    .alert-banner .main-copy{
      flex-direction: column;
    }
    
  }
</style>